import * as React from 'react';

import { RotatingArc } from '../RotatingArc/RotatingArc';

import styles from './styles.css';

export const SuccessCircle = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['circle']}></div>
      <RotatingArc />
      <div className={styles['checkmark']}></div>
    </div>
  );
};
